import { SwitchButton, type SwitchButtonValue } from "@/components/molecules/SwitchButton/SwitchButton";
import {
  BarbsIconType,
  type BarbsIconTypeCustomOptions,
  type BarbsIconType as BarbsIconTypeValue,
  getBarbsIconType,
} from "@/constants/layerConfigAttributes";
import { FormField } from "@/overlay/components/form-field";
import { t } from "@lingui/core/macro";
import "./BarbsIconTypeInput.scss";
import WindBarbIcon from "./wind-barb-icon.module.svg";

type BarbsIconTypeInputProps = {
  value?: BarbsIconTypeCustomOptions | null;
  onChange: (value: BarbsIconTypeValue) => void;
};

export function BarbsIconTypeInput({ value, onChange }: BarbsIconTypeInputProps) {
  return (
    <FormField label={t`Icon Type`} noSemanticLinking>
      <SwitchButton
        ariaLabel={t`Barbs icon type`}
        className="barbs-icon-type-input__switch"
        options={[
          {
            value: BarbsIconType.Barbs,
            label: t`Barb`,
            svgIcon: <WindBarbIcon />,
          },
          {
            value: BarbsIconType.Arrows,
            label: t`Arrow`,
            iconName: "north_east",
          },
        ]}
        value={getBarbsIconType(value)}
        onChange={(nextValue: SwitchButtonValue) => {
          if (nextValue === BarbsIconType.Barbs || nextValue === BarbsIconType.Arrows) {
            onChange(nextValue);
          }
        }}
      />
    </FormField>
  );
}
